import React from 'react';
import { useSlate, ReactEditor } from 'slate-react';
import { makeStyles } from 'design-system';
import { ExampleLabelPreview } from './ExampleLabelPreview';
// eslint-disable-next-line restrict-imports/restrict-imports
import theme from 'design-system/product/theme';

interface Props {
  examples: any;
  element: $FIXME;
  location: $FIXME;
  setLocation: $FIXME;
  readOnly: boolean;
  handleDeleteExample: $FIXME;
  setExampleModalOpen?: $FIXME;
  setExampleSelectionGridOpen?: (arg: any) => void;
  hasOpenedExample?: (taskId: string, isGoodExample: boolean) => void;
  projectTemplateId?: string;
  isMigration?: boolean;
}

const ExampleLabelPreviewContainer: React.FC<Props> = ({
  examples,
  element,
  location,
  setLocation,
  readOnly,
  handleDeleteExample,
  setExampleModalOpen,
  setExampleSelectionGridOpen,
  hasOpenedExample,
  projectTemplateId,
  isMigration,
}) => {
  const classes = useStyles();
  const editor = useSlate();

  return (
    <div>
      <>
        <div className={classes.descriptionText}>
          Green border indicates well annotated example and red border indicates poorly annotated
          example
        </div>
        <div className={classes.container}>
          {examples.map((example: Record<string, any>, i: number) => (
            <div
              key={i}
              onClick={() => {
                setLocation({
                  examples,
                  path: ReactEditor.findPath(editor, element),
                });
              }}
            >
              <ExampleLabelPreview
                taskId={example.taskId}
                isGoodExample={example.isGoodExample}
                location={location}
                onDelete={() => handleDeleteExample(example.taskId)}
                readOnly={readOnly}
                index={i}
                caption={example.caption}
                hasOpenedExample={hasOpenedExample}
                projectTemplateId={projectTemplateId}
                isMigration={isMigration}
              />
            </div>
          ))}
        </div>
        {examples.length === 0 && !readOnly && (
          <div className={classes.example}>
            <a
              onClick={() => {
                setLocation({
                  examples,
                  path: ReactEditor.findPath(editor, element),
                });
                if (setExampleSelectionGridOpen) setExampleSelectionGridOpen(true);
                else setExampleModalOpen(true);
              }}
            >
              + Add examples
            </a>
          </div>
        )}
        {examples.length > 0 && !readOnly && (
          <a
            onClick={() => {
              setLocation({
                examples,
                path: ReactEditor.findPath(editor, element),
              });
              if (setExampleSelectionGridOpen) setExampleSelectionGridOpen(true);
              else setExampleModalOpen(true);
            }}
            className={classes.addMoreBtn}
          >
            Add more examples
          </a>
        )}
      </>
    </div>
  );
};

const useStyles = makeStyles({
  loadingIconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    scrollbarWidth: 'none',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    gap: theme.spacing(3),
    borderRadius: '8px',
    marginTop: '8px',
    overflowX: 'auto',
    overflowY: 'hidden',
    padding: '4px',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  example: {
    border: '1px dashed #CCCCCC',
    borderRadius: '4px',
    height: '64px',
    textAlign: 'center',
    verticalAlign: 'middle',
    lineHeight: '64px',
  },
  descriptionText: {
    opacity: 0.5,
  },
  addMoreBtn: {
    color: theme.colors.periwinkle100,
  },
});

export default ExampleLabelPreviewContainer;
